// Gsap Start //

// =========================
// Base Settings
// =========================
const DEFAULT_DURATION = 1.3;
const DEFAULT_DELAY = 0;

const durationMap = {
  'anim-DurationZero': 0.01,
  'anim-DurationShort': 0.6,
  'anim-DurationLong': 2.5,
};

const delayMap = {
  'anim-DelayShort': 0.3,
  'anim-DelayLong': 0.6,
};

// =========================
// Animation Presets
// =========================
const animations = {
  'anim-FadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  'anim-FadeInUp': {
    from: { y: 60, opacity: 0 },
    to: { y: 0, opacity: 1 },
  },
  'anim-FadeInDown': {
    from: { y: -60, opacity: 0 },
    to: { y: 0, opacity: 1 },
  },
  'anim-FadeInLeft': {
    from: { x: -60, opacity: 0 },
    to: { x: 0, opacity: 1 },
  },
  'anim-FadeInRight': {
    from: { x: 60, opacity: 0 },
    to: { x: 0, opacity: 1 },
  },
  'anim-ZoomIn': {
    from: { scale: 0.5, opacity: 0 },
    to: { scale: 1, opacity: 1 },
  },
  'anim-ZoomOut': {
    from: { scale: 1.2, opacity: 0 },
    to: { scale: 1, opacity: 1 },
  },
};

// =========================
// Stagger Settings
// =========================
const staggerMap = {
  'anim-Stagger': 0.15,
  'anim-StaggerFast': 0.05,
  'anim-StaggerSlow': 0.3,
};

// =========================
// Parallax Settings
// =========================
const parallaxYMap = {
  'anim-ParaYSlow': 30,
  'anim-ParaYFast': 100,
  'anim-ParaYRevSlow': -30,
  'anim-ParaYRevFast': -100,
};

const parallaxXMap = {
  'anim-ParaXSlow': 30,
  'anim-ParaXFast': 100,
  'anim-ParaXRevSlow': -30,
  'anim-ParaXRevFast': -100,
};

// =========================
// Utils
// =========================
function getAnimParams(el) {
  let fromVars = {};
  let toVars = {};

  Object.keys(animations).forEach((className) => {
    if (el.classList.contains(className)) {
      fromVars = { ...fromVars, ...animations[className].from };
      toVars = { ...toVars, ...animations[className].to };
    }
  });

  let duration = DEFAULT_DURATION;
  let delay = DEFAULT_DELAY;

  Object.keys(durationMap).forEach((className) => {
    if (el.classList.contains(className)) {
      duration = durationMap[className];
    }
  });

  Object.keys(delayMap).forEach((className) => {
    if (el.classList.contains(className)) {
      delay = delayMap[className];
    }
  });

  return { fromVars, toVars, duration, delay };
}

// =========================
// Swiper Bridge
// =========================
window.playSlideAnimation = function (swiperEl) {
  if (typeof gsap === 'undefined') return;

  const activeSlide = swiperEl.querySelector('.swiper-slide-active');
  if (!activeSlide) return;

  const targets = activeSlide.querySelectorAll('.anim-items');

  targets.forEach((el) => {
    const { fromVars, toVars, duration, delay } = getAnimParams(el);

    gsap.killTweensOf(el);
    gsap.set(el, fromVars);

    gsap.to(el, {
      ...toVars,
      duration,
      delay,
      ease: 'power2.out',
    });
  });
};

// =========================
// Scroll Animations
// =========================
window.initScrollAnimations = function () {
  const elements = [...document.querySelectorAll('.anim-items')]
    .filter(el => !el.closest('.swiper') && !el.closest('.anim-StaggerWrapper'));

  elements.forEach((el) => {
    const { fromVars, toVars, duration, delay } = getAnimParams(el);

    gsap.fromTo(el, fromVars, {
      ...toVars,
      duration,
      delay,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        once: true
      }
    });
  });
};

// =========================
// Stagger
// =========================
window.initStaggerAnimations = function () {
  const wrappers = document.querySelectorAll('.anim-StaggerWrapper');

  wrappers.forEach((wrapper) => {

    let stagger = 0;

    Object.keys(staggerMap).forEach(className => {
      if (wrapper.classList.contains(className)) {
        stagger = staggerMap[className];
      }
    });

    if (!stagger) return;

    const { fromVars, toVars, duration, delay } = getAnimParams(wrapper);

    const children = wrapper.children;
    if (!children.length) return;

    gsap.fromTo(children, fromVars, {
      ...toVars,
      duration,
      delay,
      stagger,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: wrapper,
        start: 'top 85%',
        once: true
      }
    });
  });
};

// =========================
// Parallax
// =========================
window.initParallax = function () {
  const els = document.querySelectorAll('[class*="anim-Para"]');

  els.forEach((el) => {

    if (el.classList.contains('anim-items')) return;

    let amountX = 0;
    let amountY = 0;

    Object.keys(parallaxYMap).forEach(className => {
      if (el.classList.contains(className)) {
        amountY = parallaxYMap[className];
      }
    });

    Object.keys(parallaxXMap).forEach(className => {
      if (el.classList.contains(className)) {
        amountX = parallaxXMap[className];
      }
    });

    if (amountX === 0 && amountY === 0) return;

    const fromX = -amountX;
    const toX   = amountX;
    const fromY = -amountY;
    const toY   = amountY;

    gsap.set(el, { opacity: 1 });

    gsap.fromTo(
      el,
      { x: fromX, y: fromY },
      {
        x: toX,
        y: toY,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      }
    );
  });
};

// =========================
// Init
// =========================
document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);
  
  ScrollTrigger.config({
    ignoreMobileResize: false
  });

  window.initScrollAnimations();
  window.initStaggerAnimations();
  window.initParallax();
});

// =========================
// Refresh
// =========================
window.addEventListener('load', () => {
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh();
  }
});

if (typeof imagesLoaded !== 'undefined') {
  imagesLoaded(document.body, () => {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  });
}

// Gsap End //
